import { render, staticRenderFns } from "./didicash.vue?vue&type=template&id=380d87f2&scoped=true&"
import script from "./didicash.vue?vue&type=script&lang=js&"
export * from "./didicash.vue?vue&type=script&lang=js&"
import style0 from "./didicash.vue?vue&type=style&index=0&id=380d87f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d87f2",
  null
  
)

export default component.exports